import { IconButton } from '@oneaudi/unified-web-alpha-components';
import React, { useContext, type FC } from 'react';
import { useMediaQuery } from '@oneaudi/feature-app-utils';
import { UniversalStateContext } from '../context/UniversalStateContext';

type Direction = 'back' | 'forward';

export interface NavigationButtonProps {
  readonly onClick: () => void;
  readonly direction: Direction;
  readonly disabled?: boolean;
}

export const NavigationButton: FC<NavigationButtonProps> = ({
  onClick,
  direction,
  disabled = false,
}) => {
  const { i18nTexts } = useContext(UniversalStateContext)!;

  const isMobile = useMediaQuery('(max-width: 767px)'); // sm size
  const isBelowXxl = useMediaQuery('(max-width: 1919px)'); // md size

  const buttonSize = (isMobile && 'xs') || (isBelowXxl && 'sm') || 'md';

  return (
    <IconButton
      icon={direction === 'back' ? 'back' : 'forward'}
      id="icon-forward"
      onClick={onClick}
      size={buttonSize}
      title="title"
      variant="primary"
      disabled={disabled}
      aria-label={direction === 'back' ? i18nTexts.previousButtonText : i18nTexts.nextButtonText}
    />
  );
};
